import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function HowItWorks() {
    const { get } = useContent();
    return (
        <div className="content-page" data-testid="how-it-works-page">
            <div className="eyebrow" style={{ marginBottom: 12 }}>{get("hiw.eyebrow", "How It Works")}</div>
            <h1>{get("hiw.title", "Two paths.")}</h1>
            <p className="lede">{get("hiw.lede", "Whether you're here to buy or to sell — the standard is the same.")}</p>

            <div className="two-col">
                <section>
                    <h2 style={{ fontStyle: "italic" }}>{get("hiw.buying_title", "Buying")}</h2>
                    <p>{get("hiw.buying_body", "")}</p>
                    <ul>
                        <li>Authenticated by RAX curators</li>
                        <li>Condition graded transparently</li>
                        <li>Secure Stripe checkout with buyer protection</li>
                        <li>14-day returns on unworn pieces</li>
                    </ul>
                    <Link to="/shop" className="btn" style={{ marginTop: 16 }}>Shop The Edit</Link>
                </section>

                <section>
                    <h2 style={{ fontStyle: "italic" }}>{get("hiw.selling_title", "Selling")}</h2>
                    <p>{get("hiw.selling_body", "")}</p>
                    <p><strong>Commission:</strong> {get("hiw.commission", "70% consignor / 30% RAX.")}</p>
                    <p><strong>Timelines:</strong> {get("hiw.timelines", "review in 3–5 days; listed within 10; typically sold within 60.")}</p>
                    <p><strong>We accept:</strong> {get("hiw.accepted_brands", "")}</p>
                    <Link to="/sell" className="btn btn-outline" style={{ marginTop: 16 }}>Start a Submission</Link>
                </section>
            </div>
        </div>
    );
}
